import { useContext } from 'react';
import { activeTradeStatuses, TradeStatus } from '@/common/TradeCard/constants';
import TradeImage from '@/common/TradeCard/TradeImage';
import TradeContext from '~/context/common/TradeContext';
import useGetTradeInStatus from '~/hooks/common/useGetTradeStatus';
import { DetailsWrapper, TradeValue, YearMakeModel } from './Details.styles';
import TradeToolTip from './TradeToolTip';

type OwnProps = {
  ctaProps: {
    dataAnalyticsId: string;
    dataAnalyticsAttributes?: string;
    dataNativePayload?: string;
    dataQa?: string;
    href: string;
  };
  useEquity?: boolean;
};

function ViewOfferLink({ ctaProps }: OwnProps) {
  return (
    <a
      className="capitalize text-blue-2 tl-link-s"
      data-analytics-id={ctaProps.dataAnalyticsId}
      data-analytics-attributes={ctaProps.dataAnalyticsAttributes}
      data-qa={ctaProps.dataQa}
      data-native-payload={ctaProps.dataNativePayload}
      href={ctaProps.href}
    >
      view offer
    </a>
  );
}

type ValueProps = {
  equity: number;
  offerAmount: number;
  useEquity: boolean;
};

function Value({ equity, offerAmount, useEquity }: ValueProps) {
  const loanBalance = Math.abs(equity - offerAmount);

  return (
    <TradeValue data-qa="trade-card-value">
      {useEquity ? (
        <>
          {equity < 0 && <span>-</span>}
          <span>${Math.abs(equity).toLocaleString()}</span>
          {loanBalance > 0 && (
            <div className="ml-4 flex self-center">
              <TradeToolTip
                equity={equity}
                loanBalance={loanBalance}
                tradeValue={offerAmount}
              />
            </div>
          )}
        </>
      ) : (
        <span>${offerAmount.toLocaleString()}</span>
      )}
    </TradeValue>
  );
}

export default function Details({ ctaProps, useEquity = false }: OwnProps) {
  const tradeStatus = useGetTradeInStatus();
  const { selectedTrade } = useContext(TradeContext);
  const {
    vehicle: { make = '', model = '', year = 0 } = {},
    offerAmount = 0,
    equity = 0
  } = selectedTrade ?? {};
  const yearMakeModel = `${year} ${make} ${model}`;
  const showTradeValue = Boolean(activeTradeStatuses[tradeStatus]);

  return (
    <div className="col-span-2 flex w-full items-center gap-16">
      <TradeImage consumer="experiment" />

      <DetailsWrapper data-qa="trade-details-wrapper">
        <YearMakeModel
          data-qa="trade-ymm"
          showValue={showTradeValue}
          title={yearMakeModel}
        >
          {yearMakeModel}
        </YearMakeModel>

        {showTradeValue ? (
          <div
            data-qa="trade-value-wrapper"
            className="flex flex-wrap items-baseline justify-between gap-4"
          >
            <Value
              useEquity={useEquity}
              equity={equity}
              offerAmount={offerAmount}
            />
            <ViewOfferLink ctaProps={ctaProps} />
          </div>
        ) : null}
        {tradeStatus === TradeStatus.Pending ? (
          <ViewOfferLink ctaProps={ctaProps} />
        ) : null}
      </DetailsWrapper>
    </div>
  );
}
